import { render } from "./UserTrackingListTab.vue?vue&type=template&id=70c7d805&ts=true"
import script from "./UserTrackingListTab.vue?vue&type=script&lang=ts"
export * from "./UserTrackingListTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__